import Slider from "react-slick";
import Differentiator from "./Differentiator";
import { Images } from "../../helper/images";
import { DisabledNavLink } from "../../component/sidemenu";
import { SECTION_NAMES } from "../../helper/constant";

const UniqueDifferentiator = () => {

    const render = () => {
        const sliderConfig = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        return (
            <>
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="text-blue h4 mb-3 mb-0">{SECTION_NAMES.UNIQUIE_DIFFERENTIATORS}</h3>
                    <div className="d-flex align-items-center gap-4">
                        <DisabledNavLink to="/timeline"><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.TIMELINE_AND_COST}</p></DisabledNavLink>
                        <DisabledNavLink to="/track-record"><p className="m-0 p-0">{SECTION_NAMES.TRACK_RECORD}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                    </div>
                </div>
                <div className="differentiatorsslider navigatorslider">
                    <Slider className="evaluationslider navigatorslider px-5" {...sliderConfig}>
                        <div>
                            <div className="container-wrap mt-4 mb-5">
                                <img src={Images.whyIncorpAI} alt="why Incorp.AI" style={{ width: '75%' }} />
                            </div>
                        </div>
                        <div>
                            <div className="text-center"><h5><strong>Incorp.AI vs Alternatives — Differentiation</strong></h5></div>
                            <div><Differentiator /> </div>
                        </div>
                    </Slider>
                </div>
                {/* <div style={{ textAlign: "center" }}>
                    <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/timeline')}>Pred</button>
                    <button  className={`slick-arrow slick-next slick-next-page ${currentIndex === 1 ? '' : 'slick-disabled'}`} disabled={currentIndex !== 1} onClick={() => navigate('/track-record')}>Next</button>
                </div> */}
            </>
        );
    }
    return render()

};

export default UniqueDifferentiator;
